const columns: Array<any> = [
  {key: "index", width: 60},
  {
    key: "name",
    title: "Tên",
    dataIndex: "name",
    width: 600,
  },

  {key: "moTa", title: "Mô tả", dataIndex: "moTa"},
  {key: "action", width: 60},
];
export {columns};
